/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Attendancecount1Inputs */

const de__field_attendancecount1 = /** @type {(inputs: _Field_Attendancecount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Anwesenheiten`)
};

/**

* @param {_Field_Attendancecount1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_attendancecount1 = /** @type {((inputs?: _Field_Attendancecount1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Attendancecount1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_attendancecount1(inputs)
});
export { _field_attendancecount1 as "_field_attendanceCount" }